export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATEA5_BLANK.dc1bd6d4.png";